/**
 * @file 请求优先级配置
 * @description 提供交互请求、背景请求和背景延迟调度的公共配置。
 */
import type { RequestPriority } from '@/utils/requestScheduler'

/** 可传给 axios 扩展配置的请求优先级字段。 */
interface PriorityRequestConfig {
  /** 请求优先级。 */
  requestPriority: RequestPriority
  /** 是否关闭全局错误提示。 */
  suppressError?: boolean
  /** 请求超时时间，单位毫秒。 */
  timeout?: number
}

/** 交互请求配置（接稿/交稿/下载/分页等，优先处理） */
export const interactiveRequestConfig = {
  requestPriority: 'interactive'
} satisfies PriorityRequestConfig

/** 背景请求配置（统计、全量 cache refresh，静默错误并使用更长超时） */
export const backgroundRequestConfig = {
  requestPriority: 'background',
  suppressError: true,
  timeout: 30000
} satisfies PriorityRequestConfig

/**
 * 背景请求延迟：优先 requestIdleCallback，否则固定 300ms。
 * @returns 浏览器空闲或兜底定时器触发后的 Promise。
 */
export const deferBackgroundRequest = (): Promise<void> => {
  return new Promise((resolve) => {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(() => resolve(), { timeout: 500 })
      return
    }
    globalThis.setTimeout(resolve, 300)
  })
}
